import {FormattedMessage, injectIntl} from "react-intl";
import React, {useEffect, useState} from "react";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import Row from "@amzn/meridian/row";
import Input from "@amzn/meridian/input";
import {ALERT_TYPES, BOOLEAN_VALUES, G2S2_FIELD_TYPES} from "../../Constants";
import Button from "@amzn/meridian/button";
import Tag from "@amzn/meridian/tag";
import axios from "axios";
import {getErrorAlertObjectFromResponse, getHeadersForNFMS, getNFMSEndpoint} from "../../Utils";
import Alert from "@amzn/meridian/alert";
import {fetchTemplates} from "../../NetworkUtils";
import {useHistory} from "react-router-dom";
import Breadcrumb, {BreadcrumbGroup} from "@amzn/meridian/breadcrumb";
import {CREATE_FEATURES_BASE_ROUTE} from "../util/RouteConstants";

const G2S2Configuration = (props) => {
    const history = useHistory();
    const [g2s2Template, setG2s2Template] = useState();
    const [tableName, setTableName] = useState();
    const [labelName, setLabelName] = useState();
    const [fieldName, setFieldName] = useState();
    const [fieldValue, setFieldValue] = useState();
    const [fieldType, setFieldType] = useState();
    const [isKey, setIsKey] = useState();
    const [showMcmButton, setShowMcmButton] = useState(false);
    const [fields, setFields] = useState([]);
    const [defineOrderButtonVisible, setDefineOrderButtonVisible] = useState(false);
    const [g2s2Templates, setG2S2Templates] = useState([]);
    const [historyProps, setHistoryProps] = useState([{featureId: "", configId: "", mcmId: ""}]);
    const [alert, setAlert] = useState({visible: false, text:"", type:""})
    const warningAlert = {visible: true, text: "Create G2S2 Config request received.", type:ALERT_TYPES.WARNING};
    const successAlert = {visible: true, text: "Successfully created G2S2 Config", type:ALERT_TYPES.SUCCESS};

    useEffect(() => {
        try {
            setHistoryProps({
                featureId: props.location.state.featureId,
                configId: props.location.state.configId,
                mcmId: props.location.state.mcmId
            });
            setG2s2Template(props.location.state.template);
            setTableName(props.location.state.tableName);
            setLabelName(props.location.state.labelName);
            setFields(props.location.state.fields ? props.location.state.fields : []);
        } catch(error) {}

        fetchTemplates("G2S2").then(response => setG2S2Templates(response));
    }, []);

    useEffect(() => {
        if (!historyProps || !historyProps.mcmId) {
            setShowMcmButton(true);
        }
    }, [historyProps]);

    const removeField = (fieldToBeRemoved) => {
        const fieldsCopy = fields.filter(field => {return field !== fieldToBeRemoved;})
        setFields(fieldsCopy);
    }

    const addField = () => {
        const fieldsCopy = Array.from(fields);
        fieldsCopy.push({name: fieldName, value: fieldValue, type: fieldType, key: isKey});
        setFields(fieldsCopy);
    }

    const createConfig = () => {
        setAlert(warningAlert);
        const params = {
            g2s2Configuration: {
                featureId: historyProps.featureId,
                configurationId: historyProps.configId,
                template: g2s2Template,
                tableName: tableName,
                labelName: labelName,
                mcmId: historyProps.mcmId,
                fields: fields
            }
        };
        (async ()=>{
            const headers = await getHeadersForNFMS("CreateG2S2Configuration");
            axios
                .post(getNFMSEndpoint(), params, headers)
                .then((response) => {
                    if (response.status === 200) {
                        setAlert(successAlert);
                        setDefineOrderButtonVisible(true);
                    }
                })
                .catch((response) => {
                    setAlert(getErrorAlertObjectFromResponse(response));
                });
        })();

    }

    const defineOrder = () => {
        history.push({
            pathname: "/orderconfigs",
            state: {featureId: historyProps.featureId, mcmId: historyProps.mcmId}
        });
    }

    return (
        <div className="App">
            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <BreadcrumbGroup>
                        <Breadcrumb href={`#${CREATE_FEATURES_BASE_ROUTE}`}>
                            <FormattedMessage id="createConfig.heading" defaultMessage="Create New Configuration"/>
                        </Breadcrumb>
                        <Breadcrumb href={"#"}>
                            <FormattedMessage id="g2s2Config.heading" defaultMessage="Create New G2S2 Configuration"/>
                        </Breadcrumb>
                    </BreadcrumbGroup>
                </Column>
            </Row>
            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="medium none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="g2s2Config.template" defaultMessage="Template"/>
                    </Text>
                    <Select value={g2s2Template} onChange={setG2s2Template} placeholder="Select Template" width={400}>
                        {g2s2Templates.map(template => (
                            <SelectOption label={template} value={template} key={template} />
                        ))}
                    </Select>
                </Column>
            </Row>

            {showMcmButton ?
                <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                    <Column spacing="200" alignmentHorizontal="left">
                        <Text type="b200" color="secondary">
                            <FormattedMessage id="g2s2Config.mcm" defaultMessage="MCM Id"/>
                        </Text>
                        <Input id="mcm-input" value={historyProps.mcmId}
                               onChange={id => setHistoryProps({...historyProps, mcmId: id})}
                               type="text" placeholder="Enter MCM Id" width={400}/>
                    </Column>
                </Row>
                : null}

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="g2s2Config.tableName" defaultMessage="G2S2 Table Name"/>
                    </Text>
                    <Input id="config-name" value={tableName} width={400}
                           onChange={setTableName} type="text" placeholder="Enter Table name"/>
                </Column>
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="none none medium none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="g2s2Config.labelName" defaultMessage="G2S2 Label Name"/>
                    </Text>
                    <Input id="config-name" value={labelName} width={400}
                           onChange={setLabelName} type="text" placeholder="Enter Label name"/>
                </Column>
            </Row>

            <Row alignmentVertical="top" spacingInset="large large large none">
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="g2s2Config.fieldName" defaultMessage="Field Name"/>
                    </Text>
                    <Input id="field-name" value={fieldName} width={150}
                           onChange={setFieldName} type="text" placeholder="Field Name"/>
                </Column>
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="g2s2Config.fieldValue" defaultMessage="Field Value"/>
                    </Text>
                    <Input id="field-value" value={fieldValue} width={150}
                           onChange={setFieldValue} type="text" placeholder="Field Value"/>
                </Column>
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="g2s2Config.fieldType" defaultMessage="Field Type"/>
                    </Text>
                    <Select value={fieldType} onChange={setFieldType} placeholder="Field Type" width={130}>
                        {Object.entries(G2S2_FIELD_TYPES).map(([key, value]) => (
                            <SelectOption label={key} value={value} key={key} />
                        ))}
                    </Select>
                </Column>
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="g2s2Config.isKey" defaultMessage="Is Key Field"/>
                    </Text>
                    <Select value={isKey} onChange={setIsKey} placeholder="Is Key" width={130}>
                        {Object.entries(BOOLEAN_VALUES).map(([key, value]) => (
                            <SelectOption label={key} value={value} key={key} />
                        ))}
                    </Select>
                </Column>
                <Column spacing="200" alignmentHorizontal="left">
                    <Text type="b200" color="secondary">
                        <FormattedMessage id="g2s2Config.addButton" defaultMessage="."/>
                    </Text>
                    <Button type="secondary" onClick={() => addField()}>
                        <FormattedMessage id="g2s2Config.addButton" defaultMessage="Add Field"/>
                    </Button>
                </Column>
            </Row>

            <Row alignmentVertical="top" spacingInset="none none medium none" wrap="down">
                {fields.map(field => (
                    <Tag type="neutral" key={field.name} onClose={() => removeField(field)}>
                        {field.name + ", " + field.value + ", " + field.type + ", " + field.key}
                    </Tag>
                ))}
            </Row>

            <Row widths={["grid-3", "grid-2"]} alignmentVertical="top" spacingInset="xlarge xlarge xlarge none">
                <Column spacing="100" alignmentHorizontal="left">
                    <Button onClick={createConfig} disabled={defineOrderButtonVisible}>
                        <FormattedMessage id="g2s2Config.create" defaultMessage="Create Config"/>
                    </Button>
                </Column>
                <Column spacing="100" alignmentHorizontal="left">
                    <Button onClick={defineOrder} disabled={!defineOrderButtonVisible}>
                        <FormattedMessage id="g2s2Config.defineOrder" defaultMessage="Define Execution Order"/>
                    </Button>
                </Column>
            </Row>
            <Row alignmentVertical="top" spacingInset="none none medium none">
                {alert.visible ? <Alert type={alert.type}>{alert.text}</Alert> : null}
            </Row>
        </div>
    );
}

export default injectIntl(G2S2Configuration);


// WEBPACK FOOTER //
// ./src/components/create-config/G2S2Configuration.js